import React, { useEffect, useRef, useState } from "react";
import { HomeHeader } from "../../../components/headers/HomeHeader";

const HOME_HEADER_HEIGHT = 79; // adjust to your actual HomeHeader height

export const IntelligentClaimsDocumentSummarization = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const tagRef = useRef(null);
  const menuRef = useRef(null);
  const year = new Date().getFullYear();

  useEffect(() => {
    const onClickAway = (e) => {
      if (!menuOpen) return;
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        tagRef.current &&
        !tagRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("click", onClickAway);
    return () => window.removeEventListener("click", onClickAway);
  }, [menuOpen]);

  return (
    <div>
      <HomeHeader headerColor="#0D131E" textColor="#ffffff" />

      {/* Scoped styles */}
      <style>{`
        li {
          padding-top:10px;
          padding-bottom:0px;
        }

        .icds-root {
          --bg: #0a0c10;
          --panel: #0f131a;
          --panel-2: #121722;
          --text: #e6e9ef;
          --muted: #a7b0c0;
          --brand: #0b5cff;
          --brand-2: #8ab4ff;
          --ok: #1fbf75;
          --warn: #ffd166;
          --danger: #ff5d5d;
          --card-radius: 18px;
          --shadow: 0 10px 30px rgba(0,0,0,.35);
          --maxw: 1100px;
          --offset: ${HOME_HEADER_HEIGHT}px;

          color: var(--text);
          background:
            radial-gradient(1200px 800px at 10% -10%, rgba(11,92,255,.15), transparent 60%),
            radial-gradient(1200px 800px at 110% 10%, rgba(138,180,255,.1), transparent 60%),
            var(--bg);
          line-height: 1.55;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
          text-align: left;
          letter-spacing: normal;
        }

        .icds-container { max-width: var(--maxw); margin: 0 auto; padding: 24px; }

        /* Sticky page header below HomeHeader */
        .icds-header {
          position: sticky;
          top: var(--offset);
          z-index: 50;
          backdrop-filter: saturate(140%) blur(10px);
          background: linear-gradient(180deg, rgba(10,12,16,.9), rgba(10,12,16,.6));
          border-bottom: 1px solid rgba(255,255,255,.06);
        }
        .icds-nav { display:flex; align-items:center; justify-content:space-between; gap:16px; }
        .icds-logo { display:flex; align-items:center; gap:12px; text-decoration:none; color:var(--text); }
        .icds-mark { width:28px; height:28px; display:grid; place-items:center; border-radius:8px; background:linear-gradient(135deg, var(--brand), #2b90ff); box-shadow: var(--shadow); }
        .icds-word { font-weight:700; letter-spacing:.2px; }

        .icds-cta { display:flex; gap:10px; }
        .icds-btn {
          --padx: 14px; --pady: 10px;
          padding: var(--pady) var(--padx);
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,.12);
          color: var(--text);
          text-decoration: none;
          font-weight:600; font-size:14px;
          transition: transform .06s ease, background .2s ease, border-color .2s ease;
        }
        .icds-btn:hover { transform: translateY(-1px); }
        .icds-btn.primary { background: linear-gradient(135deg, var(--brand), #2b90ff); border-color: transparent; }
        .icds-btn.ghost { background: rgba(255,255,255,.03); }

        .icds-hero { padding: 56px 0 26px; position: relative; }
        .icds-hero h1 { font-size: clamp(34px, 3.8vw, 48px); line-height: 1.12; margin: 0 0 16px; letter-spacing: .3px; word-spacing: .4px; }
        .icds-hero p { color: var(--muted); font-size: clamp(16px, 1.7vw, 18px); max-width: 880px; }
        .icds-tag {
          display:inline-flex; align-items:center; gap:8px; padding:6px 12px;
          border-radius:999px; background: rgba(11,92,255,.12);
          color:#cfe0ff; border:1px solid rgba(138,180,255,.25);
          font-weight:600; font-size:13px; cursor:pointer;
        }

        .icds-grid { display:grid; gap:18px; }
        .icds-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .icds-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 900px) { .icds-cols-3, .icds-cols-2 { grid-template-columns: 1fr; } }

        .icds-card { background: linear-gradient(180deg, var(--panel), var(--panel-2)); border:1px solid rgba(255,255,255,.06); border-radius:var(--card-radius); box-shadow:var(--shadow); padding:20px 18px; }
        .icds-card h3 { margin:0 0 8px; font-size:18px; }
        .icds-card p { margin:0; color:var(--muted); }

        .icds-kv { display:flex; gap:12px; align-items:flex-start; padding:14px 0; border-top:1px dashed rgba(255,255,255,.08); }
        .icds-kv:first-child { border-top:0; }
        .icds-k { flex:0 0 180px; color:#cfe0ff; font-weight:700; text-transform:uppercase; letter-spacing:.6px; font-size:12px; }
        .icds-v { flex:1; color:var(--text); }

        .icds-badges { display:flex; gap:8px; flex-wrap:wrap; }
        .icds-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border-radius:12px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); font-weight:600; color:var(--text); }

        .icds-section { margin:30px 0; }
        .icds-section h2 { font-size:22px; margin:0 0 8px; }
        .icds-muted { color:var(--muted); }

        .icds-headline { display:flex; align-items:center; gap:12px; margin:28px 0 10px; }
        .icds-rule { height:1px; background:linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.2), rgba(255,255,255,0)); flex:1; }

        .icds-callout { border-left:3px solid var(--brand); background:rgba(11,92,255,.08); padding:14px 16px; border-radius:10px; }

        .icds-metrics { display:grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap:12px; margin-top:12px; }
        .icds-metric { text-align:center; padding:16px; border-radius:14px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); }
        .icds-metric h4 { margin:0 0 4px; font-size:20px; }
        .icds-metric p { margin:0; color:var(--muted); font-size:14px; }
        @media (max-width: 1000px) { .icds-metrics { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .icds-metrics { grid-template-columns: 1fr; } }

        .icds-footer { margin:40px 0 20px; color:var(--muted); font-size:13px; text-align:center; }

        /* Dropdown */
        .icds-menu {
          position:absolute;
          background-color:#0f131a;
          min-width:260px;
          z-index:10;
          border-radius:10px;
          box-shadow: var(--shadow);
          border:1px solid rgba(255,255,255,.12);
          margin-top:8px;
        }
        .icds-menu a { color:var(--text); padding:12px; text-decoration:none; display:block; }
        .icds-menu a:hover { background-color: var(--brand-2); }

        @media print {
          .icds-header { display:none; }
          .icds-root { background:#fff; color:#111; }
          .icds-card { background:#fff; border-color:#ddd; box-shadow:none; }
          .icds-hero .icds-tag { background:#e9f1ff; color:#0b5cff; border-color:#c9ddff; }
        }
      `}</style>

      <div className="icds-root">
        {/* Page header (sticky under HomeHeader) */}
        <header className="icds-header">
          <div className="icds-container icds-nav">
            <a
              className="icds-logo"
              href="#top"
              aria-label="Charlee.ai — Intelligent Claims Document Summarization"
            >
              <span className="icds-mark" aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M12 2l2.2 5.7L20 10l-5.8 2.3L12 18l-2.2-5.7L4 10l5.8-2.3L12 2z"
                    fill="white"
                    opacity=".9"
                  />
                </svg>
              </span>
              <span className="icds-word">Charlee.ai</span>
            </a>
            <div className="icds-cta">
              <a className="icds-btn ghost" href="#value">
                Value
              </a>
              <a className="icds-btn ghost" href="#financial-impact">
                Financial Impact
              </a>
              <a className="icds-btn primary" href="#product">
                Product
              </a>
            </div>
          </div>
        </header>

        <main className="icds-container" style={{ paddingTop: "70px" }}>
          <section className="icds-hero">
            {/* Dropdown trigger */}
            <span
              ref={tagRef}
              className="icds-tag"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              role="button"
            >
              Use Case 6 · Intelligent Claims Document Summarization{" "}
              <span aria-hidden="true">▼</span>
            </span>

            {/* Dropdown menu (SEO-friendly anchors) */}
            <div
              ref={menuRef}
              className="icds-menu"
              style={{ display: menuOpen ? "block" : "none" }}
            >
              {/* Replace hrefs with your SPA routes if desired */}
              <a href="/usecase/large-loss-alerts">
                Use Case 1 · Large Loss Alerts
              </a>
              <a href="/usecase/early-severity-signal-detection">
                Use Case 2 · Early Severity Signal Detection
              </a>
              <a href="/usecase/reserve-adequacy-monitoring">
                Use Case 3 · Reserve Adequacy Monitoring (Incurred Below
                Prediction)
              </a>
              <a href="/usecase/high-severity-potential-claims">
                Use Case 4 · High Severity Potential Claims
              </a>
              <a href="/usecase/proactive-severity-litigation-intelligence">
                Use Case 5 · Proactive Severity & Litigation Intelligence
              </a>
              <a href="/usecase/intelligent-claims-document-summarization">
                Use Case 6 · Intelligent Claims Document Summarization
              </a>
            </div>

            <h1 style={{ fontWeight: "bold" }}>
              Turn Document Overload into Actionable Intelligence
            </h1>
            <p>
              In the evolving insurance landscape, one of the biggest
              operational bottlenecks remains the manual review of claim-related
              documents—from medical records and demand letters to case
              evaluations and attorney correspondence. These documents hold
              critical insights that impact triage, reserve setting, litigation
              readiness, and settlement decisions. Yet, most teams are still
              buried under paperwork, relying on human memory and manual review
              to catch key facts.
            </p>
            <br />
            <p className="icds-muted">
              <strong>DocuCharlee</strong> eliminates this drag. Using
              AI-powered text analysis, it scans and summarizes high-volume,
              unstructured documents—extracting actionable insights like trial
              dates, exposure red flags, treatment progress, and negotiation
              signals. Whether it’s a 200-page medical file or a complex demand
              package, DocuCharlee flags what matters most—delivering clarity,
              context, and confidence to frontline claims teams. It integrates
              seamlessly with existing workflows or within 4SeeCharlee,
              amplifying its value across the claims lifecycle.
            </p>
          </section>

          <section className="icds-grid icds-cols-3">
            <div className="icds-card">
              <h3 style={{ fontWeight: "bold" }}>Role</h3>
              <p>Adjusters, FNOL Teams, Litigation Teams, Supervisors</p>
            </div>
            <div className="icds-card">
              <h3 style={{ fontWeight: "bold" }}>Job at Hand</h3>
              <p>
                Quickly understand and act on large volumes of incoming claim
                documents
              </p>
            </div>
            <div className="icds-card">
              <h3 style={{ fontWeight: "bold" }}>Trigger</h3>
              <p>
                Surge in medical records, demand packages, or case evaluations
                post-FNOL
              </p>
            </div>
          </section>

          <section className="icds-section">
            <div className="icds-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Opportunity</h2>
              <div className="icds-rule" />
            </div>
            <div className="icds-card">
              <p>
                Fast access to summarized, actionable content improves triage,
                reserve setting, and early mitigation planning.
              </p>
            </div>
          </section>

          <section className="icds-grid icds-cols-2 icds-section">
            <div className="icds-card">
              <h3 style={{ fontWeight: "bold" }}>Before Charlee</h3>
              <p>
                Teams manually reviewed large document sets, often missing key
                indicators buried in PDFs or lengthy attachments.
              </p>
            </div>
            <div className="icds-card" id="product">
              <h3 style={{ fontWeight: "bold" }}>With Charlee</h3>
              <p>
                <strong>DocuCharlee</strong> uses AI to summarize and extract
                key information—highlighting exposures, entities, legal
                milestones, and treatment details that drive claim strategy.
              </p>
            </div>
          </section>

          <section className="icds-section">
            <div className="icds-grid icds-cols-3">
              <div className="icds-card">
                <h3 style={{ fontWeight: "bold" }}>Product Used</h3>
                <div className="icds-badges">
                  <span className="icds-badge">📄 DocuCharlee</span>
                </div>
              </div>
              <div className="icds-card">
                <h3 style={{ fontWeight: "bold" }}>LOBs</h3>
                <div className="icds-badges">
                  <span className="icds-badge">All</span>
                </div>
              </div>
              <div className="icds-card" id="value">
                <h3 style={{ fontWeight: "bold" }}>Area</h3>
                <div className="icds-badges">
                  <span className="icds-badge">Claims</span>
                  <span className="icds-badge">Documents</span>
                  <span className="icds-badge">Demand Packages</span>
                  <span className="icds-badge">FNOL</span>
                </div>
              </div>
            </div>
          </section>

          <section className="icds-section">
            <div className="icds-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Value Proposition
              </h2>
              <div className="icds-rule" />
            </div>
            <div className="icds-card">
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li id="financial-impact">
                  <strong>DocuCharlee</strong> enhances claim handling across
                  the full claims lifecycle.
                </li>
                <li>
                  Improves critical metrics: cycle time, severity, accuracy,
                  compliance, and productivity.
                </li>
                <li>
                  Highlights key sections and raises alerts within the claims
                  management system for real-time impact.
                </li>
              </ul>
            </div>
          </section>

          <section className="icds-section">
            <div className="icds-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Financial Impact
              </h2>
              <div className="icds-rule" />
            </div>
            <div className="icds-card">
              <p className="icds-muted">Manual document review results in:</p>
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Delayed reserve accuracy due to missed or late-reviewed
                  details
                </li>
                <li>
                  Increased litigation risk from missed demand packages or trial
                  dates
                </li>
                <li>
                  High adjuster workload, limiting time for strategic tasks
                </li>
              </ul>
              <div className="icds-callout" style={{ marginTop: 12 }}>
                <strong>With DocuCharlee, insurers benefit from:</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                  <li>
                    <strong>75%</strong> reduction in document review time
                  </li>
                  <li>
                    <strong>$300–$500</strong> savings per claim in high-volume
                    settings
                  </li>
                  <li>
                    Earlier detection of litigation risk and better triage
                  </li>
                  <li>
                    Reallocation of adjuster time to negotiation and resolution
                  </li>
                  <li>
                    When combined with 4SeeCharlee: full-cycle intelligence
                    integration
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="icds-section">
            <div className="icds-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Results</h2>
              <div className="icds-rule" />
            </div>
            <div className="icds-card">
              <div className="icds-metrics">
                <div className="icds-metric" aria-label="Review time reduction">
                  <h4>⏱️ 75%</h4>
                  <p>reduction in document review time</p>
                </div>
                <div className="icds-metric" aria-label="Key topics flagged">
                  <h4>🔎</h4>
                  <p>
                    key topics flagged for triage, litigation, or negotiation
                  </p>
                </div>
                <div className="icds-metric" aria-label="Customer quote">
                  <h4>💬</h4>
                  <p>
                    “We’re no longer buried under paperwork—we’re acting on
                    intelligence.”
                  </p>
                </div>
                <div className="icds-metric" aria-label="Time to value">
                  <h4>🚀 24–48h</h4>
                  <p>
                    DocuCharlee summaries; 30–60 days with 4SeeCharlee
                    integration
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="icds-section">
            <div className="icds-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Why It Matters</h2>
              <div className="icds-rule" />
            </div>
            <div className="icds-card">
              <p>
                Intelligent summarization improves speed, accuracy, and exposure
                awareness—turning document overload into decision-making
                advantage.
              </p>
            </div>
          </section>

          <footer className="icds-footer">
            © {year} Charlee.ai — Use Case 6: Intelligent Claims Document
            Summarization
          </footer>
        </main>
      </div>
    </div>
  );
};
